<template>
  <div class="transactionRecordCon">
    <div class="userTitle1">
      <span class="iconfont iconcunkuan_o">
        <svg
          width="20"
          height="20"
          viewBox="0 0 48 41"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3 37.6923V3H37.6923V10H40.6923V2C40.6923 0.895431 39.7969 0 38.6923 0H2C0.895431 0 0 0.895433 0 2V38.6923C0 39.7969 0.895433 40.6923 2 40.6923H38.6923C39.7969 40.6923 40.6923 39.7969 40.6923 38.6923V31H37.6923V37.6923H3Z"
            fill="#fff"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M38.711 13.1304L40.9042 15.1773L35.6671 20.7885L40.9042 26.3996L38.711 28.4466L31.5635 20.7885L38.711 13.1304Z"
            fill="#fff"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M44.9034 13.1304L47.0966 15.1773L41.8595 20.7885L47.0966 26.3996L44.9034 28.4466L37.7559 20.7885L44.9034 13.1304Z"
            fill="#fff"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.62793 10.8597L11.6034 8.60194L17.6926 13.93L23.7818 8.60193L25.7573 10.8597L17.6926 17.9163L9.62793 10.8597Z"
            fill="#fff"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M25.6535 20.9615H9.73047V17.9615H25.6535V20.9615Z"
            fill="#fff"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M25.6535 27.1539H9.73047V24.1539H25.6535V27.1539Z"
            fill="#fff"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.1924 30.9615L16.1924 15.0385L19.1924 15.0385L19.1924 30.9615L16.1924 30.9615Z"
            fill="#fff"
          />
        </svg>
      </span>
      自助返水
      <div class="switch-wrapper">
        <span
          v-for="(name, index) in titleBtnArr"
          :key="index"
          :class="titleBtnIndex == index ? 'active' : ''"
          @click="onTables(index)"
          >{{ name }}</span
        >
      </div>
    </div>
    <div v-if="titleBtnIndex == 0">
      <ul class="rake-ul">
        <li>
          <span class="amount">返水金额</span>
          <span class="amount">操作</span>
        </li>
        <li>
          <span class="amount">{{ $store.state.returnWaterMoney }}</span>
          <span
            class="btn"
            @click="returnWaterGet"
            :class="disabledGetReturnWater ? 'disableBtn' : 'unDisabledBtn'"
            >领取</span
          >
        </li>
      </ul>
    </div>
    <div class="select-con" v-if="titleBtnIndex == 1">
      <el-col :span="1">时间筛选:</el-col>
      <el-col :span="3">
        <el-date-picker
          type="date"
          placeholder="年/月/日"
          v-model="form.startTime"
          :editable="false"
          :clearable="false"
          style="width: 100%; cursor: pointer"
        ></el-date-picker>
      </el-col>
      <el-col class="line" :span="1">至</el-col>
      <el-col :span="3">
        <el-date-picker
          type="date"
          placeholder="年/月/日"
          v-model="form.endTime"
          :editable="false"
          :clearable="false"
          style="width: 100%"
        ></el-date-picker>
      </el-col>
      <el-col :span="1" :offset="3">
        <el-button @click="getListData()" class="con-btn">查询</el-button>
      </el-col>
      <el-col :span="1">
        <el-button @click="reset()" class="con-btn">重置</el-button>
      </el-col>
    </div>
    <div v-if="titleBtnIndex == 1">
      <el-table :data="tableData" class="myTable" height="650">
        <el-table-column
          prop="orderNo"
          label="订单号"
          align="center"
          width="200"
        ></el-table-column>
        <el-table-column
          prop="createdAt"
          label="交易时间"
          align="center"
          width="200"
        ></el-table-column>
        <el-table-column
          prop="payChannel"
          label="返水类型"
          align="center"
          width="200"
        ></el-table-column>
        <el-table-column
          prop="amount"
          label="金额"
          align="center"
          width="200"
        ></el-table-column>
        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="scope">
            <span
              v-show="scope.row.type === 16"
              class="cursorPoint"
              @click="details(1, scope.row)"
              >详情</span
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        layout="prev, pager, next"
        :total="total"
        :page-size="15"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        style="float: right"
      ></el-pagination>
    </div>
    <Return-Water-Record
      ref="returnWaterRecord"
      v-show="titleBtnIndex == 2"
    ></Return-Water-Record>
    <div data-v-2ff829c2 class="tip-danye" v-show="titleBtnIndex == 3">
      1、仅统计未返水的有效打码，并可领取返水优惠。
      <br />
      <br />2、当日返水总额扣除已返水金额如有剩余有效打码
      ,次日15:00（北京时间）系统自动派送返水。
      <br />
      <br />3、自助返水只统计电子跟棋牌，不包括彩票和真人。
      <br />
    </div>

    <ReturnWater @details="details" ref="returnWater"></ReturnWater>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ReturnWater from "../../components/returnWater/returnWater.vue";
import ReturnWaterRecord from "../../components/returnWaterRecord/returnWaterRecord";
export default {
  data() {
    return {
      titleBtnArr: ["自助返水", "返水记录", "返水详情", "返水比例"],
      titleBtnIndex: 0,
      tableData: [],
      total: 0,
      currentPage: 1,
      typeOrMode: "",
      form: {
        startTime: "",
        endTime: "",
      },
      formDetail: {
        moneyMin: "",
        moneyMax: "",
        dStartTime: "",
        dEndTime: "",
      },
      gameList: [],
      apiUrl: this.$api.query,
      disabledGetReturnWater: true, //默认不可以领取返水
    };
  },
  components: {
    ReturnWater,
    ReturnWaterRecord,
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  mounted() {
    setTimeout(() => {
      this.getReturnWaterMoneyFun();
    }, 1000);
  },
  methods: {
    details(type, data) {
      if (data) {
        var betNo = data.betNo;
      }
      this.$refs.returnWaterRecord.According(type, betNo);
      this.titleBtnIndex = 2;
    },
    onTables(index) {
      this.titleBtnIndex = index;
      this.reset();
      this.apiUrl = this.$api.rebates;

      if (this.titleBtnIndex == 0) {
        this.getReturnWaterMoneyFun();
      } else if (this.titleBtnIndex == 1) {
        this.getListData(1);
      }
    },
    handleCurrentChange(index) {
      this.currentPage = index;
      this.getListData(index);
    },
    reset() {
      // this.tableData = [];
      this.currentPage = 1;
      this.form.endTime = "";
      this.form.startTime = "";
    },
    // 查询列表数据
    getListData(val = 1) {
      let form = this.form;
      this.currentPage = val;
      form.startTime
        ? (form.startTime = this.format(form.startTime, "yyyy-MM-dd HH:mm:ss"))
        : (form.startTime = "");
      form.endTime
        ? (form.endTime = this.format(form.endTime, "yyyy-MM-dd 23:59:59"))
        : (form.endTime = "");
      form.memberId = this.userInfo.userId;
      this.$nkhttp.http(this.apiUrl, form, "post", (res) => {
        if (res && res.list && res.list.length > 0 && this.titleBtnIndex == 1) {
          res.list.map((item) => {
            item.createdAt = this.conversionTime(item.createdAt);
            item.orderNo = item.betNo;
            item.amount = this.$common.setNumFixed(item.rebateAmount, 2);
            item.payChannel = item.typeName;
          });
          this.tableData = res.list;
          this.total = res.total;
        } else {
          this.tableData = [];
          this.total = 0;
        }
      });
    },
    conversionTime(timeStamp) {
      if (timeStamp > 0) {
        var date = new Date();
        date.setTime(timeStamp);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? "0" + m : m;
        var d = date.getDate();
        d = d < 10 ? "0" + d : d;
        var h = date.getHours();
        h = h < 10 ? "0" + h : h;
        var minute = date.getMinutes();
        var second = date.getSeconds();
        minute = minute < 10 ? "0" + minute : minute;
        second = second < 10 ? "0" + second : second;
        return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + second;
      } else {
        return "";
      }
    },
    format(time, format) {
      var t = new Date(time);
      var tf = function (i) {
        return (i < 10 ? "0" : "") + i;
      };
      return format.replace(/yyyy|MM|dd|HH|mm|ss/g, function (a) {
        switch (a) {
          case "yyyy":
            return tf(t.getFullYear());
            break;
          case "MM":
            return tf(t.getMonth() + 1);
            break;
          case "mm":
            return tf(t.getMinutes());
            break;
          case "dd":
            return tf(t.getDate());
            break;
          case "HH":
            return tf(t.getHours());
            break;
          case "ss":
            return tf(t.getSeconds());
            break;
        }
      });
    },
    returnWaterGet() {
      var _this = this;
      if (this.disabledGetReturnWater) {
        //禁用
        this.$message.error("返水额度低于满足条件，无法领取！");
        return;
      }
      this.$refs.returnWater.openDialog();
    },
    getReturnWaterMoneyFun() {
      var data = "?memberId=" + this.$common.getUser().user_id;
      this.$nkhttp.http(this.$api.getReturnWaterMoney, data, "get", (res) => {
        var num = "";
        if (res && res.rebateAmount * 1 > 0) {
          num = this.$common.setNumFixed(res.rebateAmount, 2);
          this.$store.commit("setReturnWaterMoney", num);
        } else {
          num = "0.00";
          this.$store.commit("setReturnWaterMoney", num);
        }

        if (Number(num) < Number(res.rebateDown)) {
          //待领取返水<最低返水金额
          this.disabledGetReturnWater = true;
        } else {
          this.disabledGetReturnWater = false;
        }
      });
    },
  },
};
</script>

<style lang='scss'>
.transactionRecordCon {
  width: 100%;
  height: 100%;
  .switch-wrapper {
    height: 32px;
    margin-left: 30px;
    margin-right: 30px;
    margin-top: 10px;
    width: calc(100% - 60px);
  }

  .switch-wrapper > span {
    cursor: pointer;
    font-size: 12px;
    display: inline-block;
    width: 100px;
    height: 30px;
    border: 1px solid #ddd;
    margin-right: 30px;
    text-align: center;
    line-height: 30px;
  }

  .active {
    color: #fff;
    background-color: #333;
    border: 1px solid #333;
  }

  .select-con {
    font-size: 12px;
    color: #4c4a4a;
    background: #fafafa;
    text-align: center;
    line-height: 44px;
    min-height: 44px;
    border-bottom: 1px solid #f0f0f0;
    display: flex;
    padding-left: 20px;
    padding-right: 20px;
  }
  .select-con1 {
    display: block;
  }

  .con-btn {
    text-align: center;
    width: 60px;
    height: 30px;
    line-height: 30px;
    border: 1px solid #e6e6e6;
    background-color: #f2f2f2;
    color: #4c4a4a;
    cursor: pointer;
    padding: 0;
  }

  .el-input--medium .el-input__inner {
    height: 30px;
  }

  .el-input__inner {
    height: 30px;
    border: 1px solid #d9c2bf;
  }

  .tip-danye {
    padding-top: 25px;
    padding-left: 50px;
    line-height: 25px;
  }

  .rake-ul {
    display: block;
    list-style-type: disc;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 40px;
  }

  .rake-ul li {
    height: 72px;
    display: -ms-flexbox;
    display: flex;
    font-size: 14px;
    -ms-flex-align: center;
    align-items: center;
    color: #666;
    border-bottom: 1px solid #e6e6e6;
  }

  .rake-ul .amount {
    width: 150px;
    text-align: center;
  }

  .rake-ul .btn {
    margin-left: 40px;
    width: 70px;
    line-height: 28px;
    color: #fff;
    text-align: center;
  }
  .disableBtn {
    background-color: #ccc;
  }
  .unDisabledBtn {
    background-color: #000;
    cursor: pointer;
  }
  .statusColor {
    color: red;
    width: 100%;
  }
  .el-col-2 {
    position: relative;
    i {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 4px;
    }
  }
  .cursorPoint {
    cursor: pointer;
    color: #f43b5b;
  }
}
</style>
